<cfp-login-layout>
  <cfp-login-card [title]="'login.title' | translate">
    <cfp-loading-spinner
      [addMargin]="false"
      [loading]="isLoading()"
      [error]="!!errorMessage()"
      [errorMessage]="errorMessage()"
    />

    @if (!isLoading()) {
      <div class="text-center">
        <button (click)="closeWindow()" type="button" class="btn btn-primary mt-5">
          {{ 'close.button' | translate }}
        </button>
      </div>
    }
  </cfp-login-card>
  <cfp-footer-text />
</cfp-login-layout>
